import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {withRouter} from "react-router-dom";
import {action, computed, observable} from "mobx";
import BaseConfirmationDialog from '../../../components/dialog/BaseConfirmationDialog';
import {go} from '../../../utils/navigationUtility';
import {DialogTypes} from '../../../constants/enums';

@withRouter
@inject('dialogStore', 'inviteMemberStore')
@observer
class StudentAddConfirmDialog extends Component {
    @observable forceClose = false;

    @action goToNoteBook = () => {
        this.close()
        go(`/home/select/student/${this.props.inviteMemberStore.student.id}`);
    }

    @action close = () => {
        const {closeDialog} = this.props.dialogStore;
        this.forceClose = true;
        closeDialog(DialogTypes.StudentAddConfirmDialog)
    }

    @computed get showDialog() {
        return this.props.dialogStore.getDialogState(DialogTypes.StudentAddConfirmDialog)
    }

    render() {
        const {student} = this.props.inviteMemberStore;
        const dialogText = student.email ? 'with': 'without'

        return <BaseConfirmationDialog
            isCancel={false}
            onSubmit={this.goToNoteBook}
            onDismiss={this.close}
            open={this.showDialog}
            buttonText={'goTo.notebook'}
            text={{message : `student.add.confirm.${dialogText}.mail` , itemName: student.name, question: 'student.added.successfully'}}
            withConfirm={true}
        />
    }
}

export default StudentAddConfirmDialog;
